// JivoSite configuration utility
export const getJivoSiteConfig = () => {
  return {
    widgetId: import.meta.env.VITE_JIVOSITE_WIDGET_ID || '',
    hideOnLoad: true, // Скрываем виджет по умолчанию
  }
}

export const loadJivoSiteScript = () => {
  const config = getJivoSiteConfig()

  // Устанавливаем конфигурацию до загрузки скрипта
  window.jivo_config = {
    widget_id: config.widgetId,
    hide_on_load: config.hideOnLoad,
    hide_widget: config.hideOnLoad,
    widget_button_hide: true, // Скрываем кнопку виджета
  }

  // Загружаем скрипт JivoSite
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = `//code.jivosite.com/script/widget/${config.widgetId}`
  
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  }
}
